import React from 'react';

const NoChatHistoryIcon: React.FC = () => (
  <svg width="255" className='w-25 h-25' height="204" viewBox="0 0 255 204" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="No Chat History">
      <path
        id="Fill 1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.053 2.8092C114.735 2.8092 93.3036 10.8921 76.3811 24.4154H49.031C45.4777 24.4154 42.5704 27.3323 42.5704 30.8973C42.5704 34.4623 45.4777 37.3792 49.031 37.3792H62.9502H67.0291C70.5824 37.3792 73.4897 40.296 73.4897 43.861C73.4897 45.6414 72.7618 47.2662 71.5903 48.4372C70.4231 49.6126 68.8036 50.3429 67.0291 50.3429H58.327H53.522H30.0798C26.5264 50.3429 23.6191 53.2597 23.6191 56.8248C23.6191 60.3898 26.5264 63.3066 30.0798 63.3066H46.862C41.7959 75.2514 38.9899 88.3945 38.9899 102.198C38.9899 107.206 39.3603 112.128 40.071 116.938C40.3681 118.947 40.7256 120.939 41.1434 122.91C53.3325 121.038 66.2624 119.535 79.7608 118.437L80.7773 119.366L81.7335 118.281C97.9497 117.015 114.971 116.341 132.527 116.341C169.827 116.341 204.731 119.383 234.575 124.673C235.725 119.669 236.5 114.522 236.866 109.259C237.034 106.925 237.116 104.57 237.116 102.198C237.116 47.3051 192.766 2.8092 138.053 2.8092Z"
        fill="#F1F2F7"
      />
      <path
        id="Fill 3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4598 50.0435H6.54444C2.945 50.0435 0 53.0192 0 56.6562C0 60.2932 2.945 63.2689 6.54444 63.2689H10.4598C14.0592 63.2689 17.0042 60.2932 17.0042 56.6562C17.0042 53.0192 14.0592 50.0435 10.4598 50.0435Z"
        fill="#F1F2F7"
      />
      <g id="Group 7">
        <mask
          id="mask0_3745_270340"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="41"
          y="116"
          width="214"
          height="86"
        >
          <path
            id="Clip 6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M254.999 116.484V201.192H148.005H41.0098V116.484H254.999Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_3745_270340)">
          <path
            id="Fill 5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M254.999 149.234C254.999 152.777 252.093 155.675 248.54 155.675H207.284C205.509 155.675 203.891 156.401 202.724 157.569C201.553 158.733 200.824 160.347 200.824 162.116C200.824 165.659 203.731 168.557 207.284 168.557H214.949C216.722 168.557 218.342 169.283 219.509 170.451C220.68 171.615 221.408 173.229 221.408 174.998C221.408 178.541 218.501 181.439 214.949 181.439H197.324C180.767 193.84 160.193 201.192 137.896 201.192C90.2754 201.192 50.5046 167.677 41.0098 123.011C53.1959 121.152 66.1227 119.657 79.6179 118.567L80.6337 119.49L81.5901 118.412C97.802 117.154 114.82 116.484 132.371 116.484C169.661 116.484 204.558 119.507 234.394 124.763C232.944 131.023 230.894 137.052 228.31 142.793H248.54C250.319 142.793 251.929 143.519 253.1 144.687C254.272 145.851 254.999 147.465 254.999 149.234Z"
            fill="#E8EBF2"
          />
        </g>
      </g>
      <path
        id="Fill 8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M236.167 108.965C235.802 114.329 235.027 119.573 233.879 124.673C204.075 119.283 169.216 116.183 131.966 116.183C114.434 116.183 97.4349 116.87 81.2402 118.16L92.4711 105.147L109.942 116.548L133.592 110.018L174.278 116.183L191.941 110.018L196.414 116.183L207.087 108.261L217.061 117.402L232.791 104.834L236.167 108.965Z"
        fill="#E0E2EE"
      />
      <path
        id="Fill 10"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.188 114.659C182.662 108.156 185.225 100.444 185.158 92.1909C184.976 69.2357 164.526 50.7897 139.483 50.9895C114.441 51.1898 94.2886 69.9613 94.4719 92.9165C94.6553 115.871 115.105 134.318 140.147 134.118C149.095 134.046 157.417 131.603 164.411 127.446L183.121 131.851L178.188 114.659Z"
        fill="#D8DBEA"
      />
      <path
        id="Fill 12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.587 91.5717C126.608 94.18 124.51 96.3116 121.902 96.3324C119.293 96.3536 117.161 94.2553 117.141 91.647C117.12 89.0383 119.217 86.9071 121.826 86.8859C124.434 86.8651 126.566 88.9629 126.587 91.5717Z"
        fill="#BEC0D6"
      />
      <path
        id="Fill 14"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.591 91.5712C143.612 94.18 141.514 96.3116 138.905 96.3324C136.297 96.3531 134.165 94.2553 134.145 91.647C134.123 89.0383 136.221 86.9067 138.83 86.8859C141.438 86.8651 143.57 88.9629 143.591 91.5712Z"
        fill="#BEC0D6"
      />
      <path
        id="Fill 16"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.601 91.5712C160.622 94.1796 158.524 96.3111 155.915 96.3324C153.306 96.3531 151.175 94.2553 151.154 91.6466C151.133 89.0378 153.231 86.9067 155.84 86.8859C158.448 86.8647 160.58 88.9629 160.601 91.5712Z"
        fill="#BEC0D6"
      />
      <path
        id="Fill 18"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.2429 118.06L80.3267 119.004L79.3535 118.195C79.9801 118.146 80.6117 118.101 81.2429 118.06Z"
        fill="#F1F2F7"
      />
      <path
        id="Fill 20"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.7422 124.673C89.7422 127.673 90.7016 130.466 92.3504 132.816L90.6005 139.088L97.4139 137.431C99.9755 138.921 103.013 139.788 106.274 139.788C115.405 139.788 122.806 133.02 122.806 124.673C122.806 116.325 115.405 109.558 106.274 109.558C97.1435 109.558 89.7422 116.325 89.7422 124.673Z"
        fill="url(#paint0_linear_3745_270340)"
      />
      <path
        id="Fill 22"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.525 124.673C110.525 125.716 111.371 126.562 112.415 126.562C113.458 126.562 114.304 125.716 114.304 124.673C114.304 123.63 113.458 122.783 112.415 122.783C111.371 122.783 110.525 123.63 110.525 124.673Z"
        fill="white"
      />
      <path
        id="Fill 24"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.859 124.673C104.859 125.716 105.705 126.562 106.749 126.562C107.792 126.562 108.638 125.716 108.638 124.673C108.638 123.63 107.792 122.783 106.749 122.783C105.705 122.783 104.859 123.63 104.859 124.673Z"
        fill="white"
      />
      <path
        id="Fill 26"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.2441 124.673C98.2441 125.716 99.0899 126.562 100.133 126.562C101.177 126.562 102.023 125.716 102.023 124.673C102.023 123.63 101.177 122.783 100.133 122.783C99.0899 122.783 98.2441 123.63 98.2441 124.673Z"
        fill="white"
      />
      <path
        id="Fill 28"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.3503 118.303C65.8564 119.403 52.9309 120.909 40.7459 122.783C40.3283 120.809 39.9709 118.814 39.6738 116.802L60.56 101.056L79.3503 118.303Z"
        fill="#E0E2EE"
      />
      <path
        id="Fill 30"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173.822 150.651C173.822 152.477 157.327 153.958 136.979 153.958C116.631 153.958 100.137 152.477 100.137 150.651C100.137 148.826 116.631 147.345 136.979 147.345C157.327 147.345 173.822 148.826 173.822 150.651Z"
        fill="#D8DBEA"
      />
      <path
        id="Fill 32"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M234.285 181.353C230.648 181.353 227.672 178.378 227.672 174.741C227.672 171.104 230.648 168.128 234.285 168.128C237.922 168.128 240.897 171.104 240.897 174.741C240.897 178.378 237.922 181.353 234.285 181.353Z"
        fill="#E1E3EF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3745_270340"
        x1="106.274"
        y1="94.443"
        x2="76.1653"
        y2="127.374"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8960" />
        <stop offset="1" stopColor="#FF62A5" />
      </linearGradient>
    </defs>
  </svg>
);

export default NoChatHistoryIcon;
